const KeenSlider = window.KeenSlider

const { getOffsetTop } = window.BAO.Utils
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class FeaturedProducts extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 20,
        },
        breakpoints: {
          '(min-width: 901px)': {
            disabled: true,
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setOverlayOpacity()
  }

  setOverlayOpacity () {
    if (!this.offsetHeight) return

    const maxBackgroundOpacity = 0.2
    const maxBlur = 10 // in pixels

    const elementStartPoint = getOffsetTop(this)
    const elementEndPoint = elementStartPoint + window.innerHeight / 2

    if (this.lastKnownY <= elementStartPoint) {
      this.els.feature.element.style.setProperty('--Background_Opacity', 1)
      this.style.setProperty('--Filter_Blur', '0px')
      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.els.feature.element.style.setProperty(
        '--Background_Opacity',
        1 - maxBackgroundOpacity,
      )
      this.style.setProperty('--Filter_Blur', `${maxBlur}px`)
      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint
    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const backgroundOpacityAmount =
      1 - maxBackgroundOpacity * scrollYAsAPercentageOfJourney

    const blurAmount = maxBlur * scrollYAsAPercentageOfJourney

    this.els.feature.element.style.setProperty(
      '--Background_Opacity',
      backgroundOpacityAmount,
    )
    this.style.setProperty('--Filter_Blur', `${blurAmount}px`)
  }
}

if (!customElements.get('featured-products')) {
  customElements.define('featured-products', FeaturedProducts)
}
